import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    color: '#fff',
    borderRadius: '5px',
    fontWeight: 500,
    letterSpacing: 0.5,
  },
  cancelButton: {
    width: '20%',
    marginRight: '15px',
    backgroundColor: theme.palette.custom.darkGreyBg,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.between('xs', 'md')]: {
      width: '48%',
    },
  },
  saveButton: {
    width: '20%',
    marginLeft: '15px',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      boxShadow: `0 0 0 2px ${theme.palette.primary.dark} inset`,
      color: theme.palette.custom.black,
    },
    [theme.breakpoints.between('xs', 'md')]: {
      width: '48%',
    },
  },
}));

const ButtonAction = ({
  cancelHandler,
  formik,
  saveLabel,
  cancelLabel,
  classes,
  name,
  justifyContent = 'flex-end',
}) => {
  const buttonActionClasses = useStyles();
  return (
    <Box display="flex" justifyContent={justifyContent}>
      <Button
        className={`${classes.submitButton} ${buttonActionClasses.button} ${buttonActionClasses.cancelButton}`}
        data-testid={`cancel-${name}`}
        onClick={() => {
          cancelHandler({ name, formik });
        }}
      >
        {cancelLabel}
      </Button>
      <Button
        className={`${classes.submitButton} ${buttonActionClasses.button} ${buttonActionClasses.saveButton}`}
        data-testid={`save-${name}`}
        onClick={() => {
          formik.handleSubmit();
        }}
      >
        {saveLabel}
      </Button>
    </Box>
  );
};

export default ButtonAction;
